import { render } from "./BarsChart.vue?vue&type=template&id=5b3ffff0"
import script from "./BarsChart.vue?vue&type=script&lang=js"
export * from "./BarsChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__